// extracted by mini-css-extract-plugin
export default {"draggable":"draggable_draggable__IqjGb","draggableItem":"draggable_draggableItem__y+ctS","draggableItemContent":"draggable_draggableItemContent__99Odl"};